import {Component, ElementRef, HostListener, Inject, Input, ViewChild, AfterViewInit, OnDestroy, Output, EventEmitter, inject, OnInit} from '@angular/core';
import {CommonModule, DOCUMENT} from '@angular/common';
import { Subscription } from 'rxjs';

import { ConnectionService } from '@services/connection-service';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import { BroadcastService } from '@services/broadcast-service';
import { AppWebBridgeService } from '@services/app-web-bridge-service';
import { WindowRefService } from '@services/window-ref-service';
import { TimeService } from '@services/time-service';
import { EventLoggerService } from '@services/event-logger-service';
import { FirebaseAndBranchEvent } from '@services/event-logger-service/event-logger.constant';
import { InstructionsService } from '@services/instructions-service/instructions.service';
import { RegimenService } from '@services/regimen-service/regimen.service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { UserService } from '@services/user';
import { ApiClientConstant } from '@cureskin/api-client';
import { Catalog, RegimenClass } from '@cureskin/api-client/src/server-api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { KnowMoreClicked, InstructionCardComponent } from '@shared/regimen-instruction/instruction-card/instruction-card.component';
import { ButtonModule } from '@components/button';
import { VideoPlayerModule } from '@components/video-player/video-player.module';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { DirectivesModule } from '@directives/directives.module';
import { DietGuidanceBannerComponent } from '@shared/diet-guidance-banner/diet-guidance-banner.component';
import { AppConfig } from '../../app.config';
import { Regimen, AllocatedRegimen, CollapsableCardItem, CollapsableCardState, FollowUpReport } from '../../app-constant-types';
import { REGIMEN_ROUTE_PATHS, REGIMEN_QUERY_PARAMS, REGIMEN_STATUS_BAR_COLOR } from '../../user/user-view/user-regimen/regimen.constants';

@Component({
  selector: 'regimen-instruction',
  templateUrl: './regimen-instruction.html',
  standalone: true,
  imports: [CommonModule, CsIconModule, ButtonModule, VideoPlayerModule, LoadingModule, InstructionCardComponent, DirectivesModule, DietGuidanceBannerComponent],
})
export class RegimenInstructionComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('videoPlayer', { static: false }) videoPlayer: ElementRef<HTMLVideoElement>;
  @ViewChild('morningAndNightTabs', { static: false }) morningAndNightTabs: ElementRef<HTMLElement>;
  @ViewChild('nightElementRelative', { static: false }) nightElementRelative: ElementRef<HTMLElement>;

  @ViewChild('nightElement') set nightBlock(block: ElementRef<HTMLElement>) {
    if (!block) return;
    if (this.onNightBlockClick || this.onMorningBlockClick) return;

    // Add check for initial load
    if (this.initialLoadComplete) return;
    this.initialLoadComplete = true;

    // Only set these values during initial load
    if (this.todayDay === undefined) {
      this.todayDay = new Date().getDate();
      this.todayDayVal = new Date().getDay();
    }

    this.scrollToActiveSection();
  }
  regimen: AllocatedRegimen = {} as AllocatedRegimen;
  dayAfterDelivery: number = -1;
  changeInstructionForRepairProduct: boolean = true;
  morningProducts: any[] = [];
  nightProducts: any[] = [];
  weekArray: any[] = [];
  currentDate: any;
  todayDay: number;
  todayDayVal: any;
  supportTicketId: any;
  onNightBlockClick: boolean = false;
  isCustomInstruction: boolean = false;
  isLoading: boolean = false;
  onMorningBlockClick: boolean = false;
  thumbsUpDown: boolean = false;
  isDayTime: boolean;
  private nightElementObserver: IntersectionObserver | null = null;
  days: any[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'];
  monthNames: any[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  isPlaying: boolean = false;
  unChangedTodayDay: number = new Date().getDate();
  @Input('regimen')
  set regimenObject(r: AllocatedRegimen) {
    const regimenClassChanged = !!this.regimen?.class && this.regimen.class !== r.class;
    this.regimen = JSON.parse(JSON.stringify(r));
    if (regimenClassChanged && !this.isRouteMode) this.initialLoadComplete = false;
    this.onNightBlockClick = false;
    this.onMorningBlockClick = false;

    // Recalculate isDayTime based on current time when switching tabs
    const MORNING_START_HOUR = 6;
    const NIGHT_START_HOUR = 20;
    const hours = new Date().getHours();
    this.isDayTime = hours >= MORNING_START_HOUR && hours < NIGHT_START_HOUR;

    this.processRegimen().then(() => {
      // Reinitialize the intersection observer after view is updated
      setTimeout(() => {
        this.setupNightElementObserver();
      }, 100);
    });
    this.checkForInstructionUpdate();
  }
  user: any;
  @Input('supportTicketId')
  set supportTicket(id: any) {
    this.supportTicketId = id;
  }
  @Input('experiments')
  set experiments(data: any) { }
  @Input('newInstructionUIExperiment') newInstructionUIExperiment: boolean;
  @Input('dietBannerV2') dietBannerV2: boolean;
  @Input('dietBannerRevamp') dietBannerRevamp: boolean;
  @Input('scrollingDown') scrollingDown: boolean;
  thumbnailImageUrl: string;
  thumbnailImageUrlRebranding: string;
  videoURL: string;
  productIds: Array<any> = [];
  videoPlayed: boolean = false;
  daysData: any = [];
  userLanguage: string;
  isTabsVisible: boolean;
  productUpdatePopupEnabled: boolean = false;
  defaultDoctorImage: string = 'https://cdn.cureskin.com/app/img/dr-charu-main-concern.png';
  userDrImage: string;
  regimenModifications: string[] = [];
  latestFollowupReport: FollowUpReport;
  latestReportDoctorName: string;
  selectedDate: Date = new Date();
  collapsableCard: CollapsableCardState = {
    onHold: [],
    removed: [],
    instructionChanged: [],
  };
  removedProducts: Catalog[];
  showGoToCart: boolean = false;
  dontShowCTA: boolean = false;
  private initialLoadComplete: boolean = false;
  showInstructionReminderTurnOffPopup: boolean = false;
  isInstructionReminderEnabled: boolean = false;
  recentlyDeliveredMargIds: Array<string> = [];
  showReminderContainer: boolean = true;
  reminderEventSent: boolean = false;
  private readonly REMINDER_CLOSE_DELAY_MS: number = 5000;

  @Output() morningNightTabsVisibilityChange = new EventEmitter<boolean>();
  @Output() reminderToggleChange = new EventEmitter<boolean>();
  @Input('reminderToggle') reminderToggle: boolean;

  // Dual-mode: route mode when rendered as a route child of the shell
  isRouteMode = false;
  isInternalUser = false;
  isKeyboardVisible = false;
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly regimenService = inject(RegimenService);
  private readonly experimentService = inject(ExperimentService);
  private readonly instructionsService = inject(InstructionsService);
  private readonly userService = inject(UserService);
  private readonly userAllocatedDoctorService = inject(UserAllocatedDoctorService);
  private routeSubscription: Subscription | null = null;
  private keyboardSubscription: Subscription | null = null;

  constructor(private conn: ConnectionService,
    private broadcast: BroadcastService,
    public appConfig: AppConfig,
    private appBridge: AppWebBridgeService,
    private window: WindowRefService,
    private timerService: TimeService,
    private eventLoggerService: EventLoggerService,
    private readonly router: Router,
    // eslint-disable-next-line new-cap
    @Inject(DOCUMENT) private document: Document) { }

  @HostListener('document:fullscreenchange')
  onFullscreenChange(): void {
    if (!this.document.fullscreenElement) {
      this.closeVideo();
    }
  }

  @HostListener('document:wheel')
  @HostListener('document:touchmove')
  cancelPendingAutoScroll(): void {
    this.initialLoadComplete = true;
  }

  async ngOnInit(): Promise<void> {
    this.appBridge.setStatusBarColor(REGIMEN_STATUS_BAR_COLOR);
    this.onMorningBlockClick = false;
    this.onNightBlockClick = false;
    this.isRouteMode = this.activatedRoute.snapshot.routeConfig?.path === REGIMEN_ROUTE_PATHS.INSTRUCTIONS;
    if (this.isRouteMode) await this.initRouteMode();
    this.getWeeklyCalendar();
    this.user = this.conn.getActingUser();
    this.getToggleValue();
    if (!this.user?.get('instructionsFeedbackResponse') && this.supportTicketId) {
      this.thumbsUpDown = true;
    }
    if (this.regimen?.active && this.newInstructionUIExperiment) {
      await this.getRecentlyDeliveredMargIds();
      await this.getRegimenModificationsAndDoctorInfo().then((r: any): void => this.handleAutoPopup());
    }
  }

  async getRecentlyDeliveredMargIds(): Promise<void> {
    const response = await this.conn.getDeliveredMargIdsByDays(this.appConfig.Shared.Regimen.Constants.DELIVERED_MARG_ID_LOOK_BACK_DAYS).catch(() => null);
    this.recentlyDeliveredMargIds = response?.margIds ?? [];
  }


  getToggleValue() :void {
    const hasEnabled = !!this.user?.get('hasEnabledReminderForInstructions');
    this.reminderToggle = hasEnabled;
    this.showReminderContainer = !hasEnabled;
  }

  ngAfterViewInit(): void {
    this.setupIntersectionObserver();
    this.setupNightElementObserver();
  }

  setupIntersectionObserver(): void {

    // Add a small delay to ensure element is rendered
    setTimeout(() => {
      if (this.morningAndNightTabs) {
        const options = {
          root: null,
          rootMargin: `-110px 0px 0px 0px`,
          threshold: 0.2,
        };

        const observer = new IntersectionObserver(([entry]: IntersectionObserverEntry[]): void => {
          this.onIntersection(entry.isIntersecting);
        }, options);

        observer.observe(this.morningAndNightTabs.nativeElement);
      }
    }, 100); // 100ms delay
  }

  setupNightElementObserver(): void {
    // Disconnect previous observer if it exists
    if (this.nightElementObserver) {
      this.nightElementObserver.disconnect();
      this.nightElementObserver = null;
    }

    if (!this.nightElementRelative?.nativeElement) return;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };
    /**
     * This is used to check if the element is in view port or not, intersection ratio greater than 0 && isIntersecting true means,
     * screen is scrolled to the specified block
     */
    this.nightElementObserver = new IntersectionObserver(async ([entry]: any, observe: any): Promise<any> => {
      if (entry?.intersectionRatio > 0 && entry?.isIntersecting) {
        this.isDayTime = false;
      } else {
        this.isDayTime = true;
      }
    }, options);
    this.nightElementObserver.observe(this.nightElementRelative.nativeElement);
  }

  onIntersection(isIntersecting: boolean): void {
    if (this.isTabsVisible !== isIntersecting) {
      this.isTabsVisible = isIntersecting;
      this.morningNightTabsVisibilityChange.emit(this.isTabsVisible);
    }
  }

  // For variants, we need to manually update the instruction
  // as it doesn't give the translated strings
  async checkForInstructionUpdate(): Promise<void> {
    const hasVariants = this.regimen?.variants && this.regimen?.variants?.length;
    const hasTranslatedInstructionSet = this.regimen.morning[0]?.instructionSet?.areaOfApplication;
    if (hasVariants && !hasTranslatedInstructionSet) {
      await this.updateInstruction();
    }
  }

  async updateInstruction(): Promise<void> {
    this.isLoading = true;
    const regimens = await this.conn.fetchRegimens(null, true, true);
    const regimenInfo = regimens.find((each: AllocatedRegimen): boolean => each.class === this.regimen.class);
    this.regimen.morning = this.regimen?.morning?.map((product: any, index: number): any => {
      const updatedProduct = { ...product };
      delete updatedProduct?.instructionSet;
      updatedProduct.instructionSet = JSON.parse(JSON.stringify(regimenInfo?.morning[index]?.instructionSet));
      return updatedProduct;
    });

    this.regimen.night = this.regimen?.night?.map((product: any, index: number): any => {
      const updatedProduct = { ...product };
      delete updatedProduct?.instructionSet;
      updatedProduct.instructionSet = JSON.parse(JSON.stringify(regimenInfo?.night[index]?.instructionSet));
      return updatedProduct;
    });

    await this.processRegimen();
  }

  async processRegimen(): Promise<any> {
    this.isLoading = true;
    this.userLanguage = this.user?.get('languagePreference') || this.appConfig.Shared.Languages.EN;
    delete this.videoURL;
    delete this.thumbnailImageUrl;
    delete this.thumbnailImageUrlRebranding;
    this.morningProducts = [];
    this.nightProducts = [];
    this.productIds = [];
    this.regimen?.morning?.forEach((e: any): void => {
      const each = e;
      if (!this.productIds.includes(e.product.objectId)) this.productIds.push(e.product.objectId);
      if (each.instructionSet) {
        const set = each.instructionSet;
        // paid/unpaid instruction videos come directly on instructionSet in the getAllocatedRegimens payload
        if (set.quantityUnit) set.quantityUnit = this.formatString(set.quantityUnit);
        if (set.areaOfApplication) set.areaOfApplication = this.formatString(set.areaOfApplication);
        if (set.frequencyOfApplication) set.frequencyOfApplication = this.formatString(set.frequencyOfApplication);
        if (set.frequencyOfApplicationEnglish) set.frequencyOfApplicationEnglish = this.formatString(set.frequencyOfApplicationEnglish);
        if (set.frequencyOfApplicationEnglish) set.newFrequencyOfApplication = this.formatFrequency(set);
        if (set.newFrequencyOfApplication) set.displayDays = this.formatStringDays(set.newFrequencyOfApplication);
        if (set.durationOfApplication) set.durationOfApplication = this.formatString(set.durationOfApplication);
        this.morningProducts.push(each);
      }
    });
    this.regimen?.night?.forEach((e: any): void => {
      const each = e;
      if (!this.productIds.includes(e.product.objectId)) this.productIds.push(e.product.objectId);
      if (each.instructionSet) {
        const set = each.instructionSet;
        // paid/unpaid instruction videos come directly on instructionSet in the getAllocatedRegimens payload
        if (set.quantityUnit) set.quantityUnit = this.formatString(set.quantityUnit);
        if (set.areaOfApplication) set.areaOfApplication = this.formatString(set.areaOfApplication);
        if (set.frequencyOfApplication) set.frequencyOfApplication = this.formatString(set.frequencyOfApplication);
        if (set.frequencyOfApplicationEnglish) set.frequencyOfApplicationEnglish = this.formatString(set.frequencyOfApplicationEnglish);
        if (set.frequencyOfApplicationEnglish) set.newFrequencyOfApplication = this.formatFrequency(set);
        if (set.newFrequencyOfApplication) set.displayDays = this.formatStringDays(set.newFrequencyOfApplication);
        if (set.durationOfApplication) set.durationOfApplication = this.formatString(set.durationOfApplication);
        this.nightProducts.push(each);
      }
    });
    await this.checkForInstructionVideo(this.userLanguage);
    this.checkForRepairProductInstructionsAlert();
    this.updateCollapsableCardOnHoldStatus();
    this.eventLoggerService.cleverTapEvent('pageOpen', JSON.stringify({ regimenId: this.regimen.regimenId, pageName: 'instruction' }), [
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.isLoading = false;
  }

  /**
   * Updates the collapsableCard status by checking onHold status
   * of products in morning and night regimens
   */
  private updateCollapsableCardOnHoldStatus(): void {
    // Reset onHold array
    this.collapsableCard.onHold = [];

    // Check morning products
    this.morningProducts?.forEach((product: any): void => {
      if (product.onHold) {
        this.collapsableCard.onHold.push({
          productId: product.product.objectId,
          isOpen: false,
        });
      }
    });

    // Check night products
    this.nightProducts?.forEach((product: any): void => {
      if (product.onHold) {
        this.collapsableCard.onHold.push({
          productId: product.product.objectId,
          isOpen: false,
        });
      }
    });
  }

  /**
   * Updates the collapsableCard status by checking removed products
   * from latest followup
   */
  private async updateCollapsableCardRemovedStatus(): Promise<void> {
    // Reset removed array
    this.collapsableCard.removed = [];

    // Only proceed if we have a latest followup report
    if (!this.latestFollowupReport?.createdAt) {
      return;
    }

    const listOfChangedRegimenProduct = await this.conn.getListOfChangedRegimenProduct(
      this.regimen.objectId,
      'productRemoved,instructionChanged',
    );

    const latestFollowupDate = new Date(this.latestFollowupReport.createdAt)
      .toISOString()
      .split('T')[0];
    // Get all removed products details
    this.removedProducts = await Promise.all(
      listOfChangedRegimenProduct
        .filter((item: any): boolean => {
          const itemDate = new Date(item.createdAt);
          itemDate.setHours(0, 0, 0, 0);

          const followupDate = new Date(this.latestFollowupReport.createdAt);
          followupDate.setHours(0, 0, 0, 0);
          return itemDate >= followupDate && item.actionQuestionUniqueId === 'productRemoved';
        })
        .map(async (item: any): Promise<Catalog> => {
          const [product] = await this.conn.findProductsById(item.product.objectId);
          return JSON.parse(JSON.stringify(product));
        }),
    );

    const pastRegimens = await this.conn.getPastRegimens(this.user, new Date(latestFollowupDate), this.regimen.class);

    // Filter and add to collapsableCard.removed
    const followupDate = new Date(this.latestFollowupReport.createdAt);
    followupDate.setHours(0, 0, 0, 0);

    (listOfChangedRegimenProduct as any)
      .filter((item: any): boolean => {
        const itemDate = new Date(item.createdAt);
        itemDate.setHours(0, 0, 0, 0);
        return itemDate >= followupDate;
      })
      .forEach((item: any): void => {
        if (item?.actionQuestionUniqueId === 'productRemoved') {
          this.collapsableCard.removed.push({
            productId: item.product.objectId,
            isOpen: false,
          });
        } else if (item?.actionQuestionUniqueId === 'instructionChanged') {
          this.collapsableCard.instructionChanged.push(item.product.objectId);
        }
      });

    await this.processRemovedInstructions(pastRegimens);
  }

  private async processRemovedInstructions(pastRegimens: any[]): Promise<void> {
    // Create map of latest regimens for removed products
    const latestRegimenMap = this.createLatestRegimenMap(pastRegimens);
    // Process each removed product
    await Promise.all(this.removedProducts.map(async (removedProduct: any): Promise<void> => {
      const latestRegimen = latestRegimenMap.get(removedProduct.objectId);
      if (!latestRegimen) return;

      // Process morning and night products
      await Promise.all([
        this.processTimeProducts('morning', latestRegimen, removedProduct),
        this.processTimeProducts('night', latestRegimen, removedProduct),
      ]);
    }));
  }

  private createLatestRegimenMap(pastRegimens: any[]): Map<string, any> {
    const latestRegimenMap = new Map();

    [...pastRegimens].reverse().forEach((pastRegimen: any): void => {
      const productIds = (pastRegimen.get('combinedProductIds') || '').split('_');

      this.removedProducts.forEach((removedProduct: any): void => {
        if (!latestRegimenMap.has(removedProduct.objectId)
            && productIds.includes(removedProduct.objectId)) {
          latestRegimenMap.set(removedProduct.objectId, pastRegimen);
        }
      });
    });

    return latestRegimenMap;
  }

  private async processTimeProducts(timeOfDay: 'morning' | 'night', latestRegimen: any, removedProduct: any): Promise<void> {
    const products = latestRegimen.get(timeOfDay) || [];

    // Process all products first and collect results
    const productsToAdd = await Promise.all(
        products
            .filter((product: any): any => {
                const matches: boolean = product.product.id === removedProduct.objectId;
                return matches;
            })
            .map(async (product: any) => {
                if (product.instructionSet) {
                    await this.updateInstructionSetLanguages(product.instructionSet);
                }
              // Destructure to remove addedTimestamp if exists
              const { addedTimestamp, ...rest } = product;
                return {
                    ...rest,
                    removedProduct,
                };
            })
    );

    // Then update the target array atomically
    const targetArray = timeOfDay === 'morning' ? this.morningProducts : this.nightProducts;
    productsToAdd.forEach(newProduct => {
        const exists = targetArray.some(existingProduct =>
            existingProduct.product.id === newProduct.product.id
        );

        if (!exists) {
            targetArray.push(newProduct);

        }
    });
  }

  private async updateInstructionSetLanguages(set: any): Promise<void> {
    const languageFields = [
      { key: 'areaOfApplication', stringKey: 'areaOfApplicationLanguageString' },
      { key: 'frequencyOfApplication', stringKey: 'frequencyOfApplicationLanguageString' },
      { key: 'quantityUnit', stringKey: 'quantityUnitLanguageString' },
      { key: 'durationOfApplication', stringKey: 'durationOfApplicationLanguageString' },
    ];

    await Promise.all(
      languageFields
        // tslint:disable-next-line:typedef
        .filter((field) => set[field.stringKey])
        // tslint:disable-next-line:typedef
        .map(async (field) => {
          // tslint:disable-next-line:typedef
          const [response] = await this.conn.getLanguageStringsById(set[field.stringKey].id);
          // eslint-disable-next-line no-param-reassign
          set[field.key] = response.get(this.userLanguage);
        }),
    );
  }

  /**
 * This method is used to get the current week starting from monday
 */
  getWeeklyCalendar(): void {
    this.weekArray = [];
    this.currentDate = new Date();
    if (!this.newInstructionUIExperiment) {
      for (let i = 1; i <= 7; i += 1) {
        const first = this.currentDate.getDate() - this.currentDate.getDay() + i;
        const day = new Date(this.currentDate.setDate(first)).toISOString().slice(0, 10);
        const dayValue = this.days[new Date(day).getDay()];
        const month = this.monthNames[new Date(day).getMonth()];
        const date = new Date(day).getDate();
        const obj = { dayValue, month, date };
        this.weekArray.push(obj);
      }
    } else {
      // New logic to place today in the middle of the week array
      for (let i = -3; i <= 3; i += 1) {
        const day = new Date(this.currentDate);
        day.setDate(this.currentDate.getDate() + i);
        const dayValue = this.days[day.getDay()];
        const month = this.monthNames[day.getMonth()];
        const date = day.getDate();

        const obj = {
          dayValue,
          month,
          date,
          fullDate: day, // Store full date for comparison
          isSelected: this.isSameDay(day, this.selectedDate),
        };
        this.weekArray.push(obj);
      }
    }
  }

  checkForRepairProductInstructionsAlert(): void {
    if (this.regimen.deliveredDate) {
      const todayDate: any = new Date();
      const regimenDeliveredDate = new Date(this.regimen.deliveredDate);
      const afterDeliveryDate1: any = this.timerService.addDays(regimenDeliveredDate, 1);
      if (todayDate > afterDeliveryDate1) {
        this.changeInstructionForRepairProduct = false;
        return;
      }
      if (todayDate.getDate() === regimenDeliveredDate.getDate()) this.dayAfterDelivery = 0;
      else if (todayDate.getDate() === afterDeliveryDate1.getDate()) this.dayAfterDelivery = 1;
      else this.changeInstructionForRepairProduct = false;
    }
  }

  formatString(text: string): string {
    return text.replace('N/A', '').trim();
  }

  /**
   * This method is used to format the instructions frequency of usage to days array.
   */
  formatFrequency(data: any, isOldUi: boolean = false): any {
    let text: string;
    if (isOldUi) {
      text = data;
    } else {
      text = data.frequencyOfApplicationEnglish;
    }
    if (!text) return '';
    const daysArray = text.split('/');
    const dayObjList = Object.keys(this.appConfig.Shared.FrequencyOfUsage.Days);
    const hasAllElems = daysArray.every((elem: any): any => dayObjList.includes(elem));
    if (isOldUi && !hasAllElems) {
      return text;
    }
    if (!isOldUi && !hasAllElems) {
      if (text.toLowerCase() !== 'all days') {
        // eslint-disable-next-line no-param-reassign
        data.isCustomInstruction = true;
      }
      return '';
    }
    this.daysData = [];
    daysArray.forEach((element: any): any => {
      if (this.appConfig.Shared.FrequencyOfUsage.Days[element]) {
        this.daysData.push(this.appConfig.Shared.FrequencyOfUsage.Days[element]);
      }
    });
    return this.daysData;
  }

  /**
   * This is used to format the array to a string with commas and & opeartor at last
   */
  formatStringDays(list: any): any {
    if (!list?.length) {
      return '';
    }
    if (list.length === 1) {
      return list.toString();
    }
    if (list.length === 2) {
      return list.join(' & ');
    }
    return `${list.slice(0, -1).join(', ')} & ${list.slice(-1)}`;
  }

  private async checkForInstructionVideo(language: string): Promise<any> {
    if ((await this.appBridge.requestOSInformation()) !== 'iOS' && !this.window.isSafariBrowser()) {
      const filenameArray = this.productIds;
      filenameArray.push(language);
      const fileName = filenameArray.join('-');
      const videoURL = `https://cdn.cureskin.com/regimen-products-video/${fileName}.webm`;
      const videoFileExists = await this.findIfProductVideoExists(videoURL);
      if (videoFileExists) {
        this.videoURL = videoURL;
        this.thumbnailImageUrl = `https://cdn.cureskin.com/regimen-products-video/regimen-instruction-thumbnail-${language}.jpg`;
        this.thumbnailImageUrlRebranding = `https://cdn.cureskin.com/regimen-products-video/regimen-instruction-thumbnail-${language}.jpg`;
        this.eventLoggerService.trackEvent('REGIMEN_PRODUCT_VIDEO_FOUND', { url: videoURL });
      } else {
        this.eventLoggerService.trackEvent('REGIMEN_PRODUCT_VIDEO_NOT_FOUND',
          { url: videoURL, class: this.regimen.class, regimenId: this.regimen.regimenId });
        if (language !== this.appConfig.Shared.Languages.EN) {
          await this.checkForInstructionVideo(this.appConfig.Shared.Languages.EN);
        }
      }
    }
  }

  logVideoPlay(): void {
    if (this.videoPlayed) return;
    this.videoPlayed = true;
    this.eventLoggerService.trackInFirebaseAndBranchForClass(FirebaseAndBranchEvent.REGIMEN_PRODUCT_VIDEO_PLAYED, this.regimen.class);
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'play-regimen-instruction-video', class: this.regimen.class }));
    this.eventLoggerService.trackEventForClass(FirebaseAndBranchEvent.REGIMEN_PRODUCT_VIDEO_PLAYED, this.regimen.class,
      { url: this.videoURL, class: this.regimen.class, regimenId: this.regimen.regimenId });
  }

  closeVideo(): any {
    if (!this.isPlaying) return;
    this.videoPlayer.nativeElement.pause();
    this.videoPlayer.nativeElement.currentTime = 0;
    this.videoPlayer.nativeElement.parentElement.classList.add('tw-hidden');
    this.isPlaying = false;
  }

  async findIfProductVideoExists(url: any): Promise<boolean> {
    try {
      const http = new XMLHttpRequest();
      http.open('HEAD', url, false);
      http.send();
      return Promise.resolve(http.status !== 404);
    } catch (err) {
      return Promise.resolve(false);
    }
  }

  get isAcneConcern(): boolean {
    const treatmentConcerns: string[] = this.regimen?.displayConcern?.treatmentConcerns ?? [];
    return treatmentConcerns.includes(this.appConfig.Shared.String.ACNE_OR_PIMPLES);
  }

  get isHairRegimen(): boolean {
    return this.regimen?.class === this.appConfig.Shared.Regimen.Class.HAIR;
  }

  get showOldDietBanner(): boolean {
    return !this.isLoading && !!this.user && this.userService.isPaidUser(this.user) && !this.dietBannerV2 && !this.dietBannerRevamp;
  }

  get showDietBannerV2(): boolean {
    return !this.isLoading && !!this.user && this.userService.isPaidUser(this.user) && this.dietBannerV2 && !this.dietBannerRevamp;
  }

  get showDietBannerRevamp(): boolean {
    return !this.isLoading && this.dietBannerRevamp && !!this.regimen;
  }

  // The fixed bottom reminder bar overlays page content; the diet banner needs extra bottom
  // clearance only when this bar is active. Mirrors the reminder section's *ngIf (intentionally
  // excludes the transient !isTabsVisible scroll state so the layout margin doesn't jump on scroll).
  // Gated on isRouteMode (the instructions route IS the instruction view) rather than the
  // showProductSummary flag, which is only set when entering via user-view-regimen.
  get showReminderBanner(): boolean {
    return this.isRouteMode
      && !this.isLoading
      && !!this.regimen
      && this.showReminderContainer
      && this.newInstructionUIExperiment
      && this.regimen.class === this.appConfig.Shared.Regimen.Class.FACE
      && this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.DELIVERED;
  }

  myDietNew(): void {
    const treatmentConcerns: string[] = this.regimen?.displayConcern?.treatmentConcerns ?? [];
    let concernType = treatmentConcerns.includes(this.appConfig.Shared.String.ACNE_OR_PIMPLES) ? 'acne' : 'non_acne';
    if (this.isHairRegimen) concernType = 'hair';
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'instructions_diet', concern_type: concernType }));
    // Land on the diet plan tab matching the instruction's regimen (FACE / HAIR).
    const regimenClass: string = this.regimen?.class;
    this.conn.navigateToURL(regimenClass ? `/notice?class=${regimenClass}` : '/notice');
  }

  onNightClick(element?: HTMLElement): void {
    this.isLoading = true;
    const windowRef = this.window.nativeWindow;
    const doc = windowRef.document;
    const nightBlockScroll = doc.getElementById('nightBlockScroll');
    if (element) {
      element.scrollIntoView(true);
    } else {
      this.isDayTime = false;
      this.onNightBlockClick = true;
      nightBlockScroll.scrollIntoView(true);
    }
    this.isLoading = false;
  }
  onMorningClick(): void {
    this.isLoading = true;
    const windowRef = this.window.nativeWindow;
    const doc = windowRef.document;
    const morningBlock = doc.getElementById('morningBlock');
    if (morningBlock) {
      this.onNightBlockClick = false;
      this.onMorningBlockClick = true;
      this.isDayTime = true;
      morningBlock.scrollIntoView(true);
    }
    this.isLoading = false;
  }

  onPlayButtonClick(instructionItem: any): void {
    if (!this.videoPlayer?.nativeElement) return;
    const activeUser = this.user || this.conn.getActingUser();
    this.userLanguage = activeUser?.get('languagePreference') || this.appConfig.Shared.Languages.EN;
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'play-product-instruction-video' }));
    const videoPlayer = this.videoPlayer.nativeElement;
    videoPlayer.parentElement.classList.remove('tw-hidden');
    videoPlayer.src = this.instructionsService.getInstructionVideoUrl(instructionItem.instructionSet, activeUser);
    const playPromise = videoPlayer.play();
    if (playPromise && !this.isPlaying) {
      playPromise.then(():void => {
        this.isPlaying = true;
      });
    }
  }

  /** Day is 6 AM–7:59 PM; night is 8 PM–5:59 AM. */
  private computeIsDayTime(): boolean {
    const MORNING_START_HOUR = 6;
    const NIGHT_START_HOUR = 20;
    const hours = new Date().getHours();
    return hours >= MORNING_START_HOUR && hours < NIGHT_START_HOUR;
  }

  private scrollToActiveSection(): void {
    this.isDayTime = this.computeIsDayTime();
    const doc = this.window.nativeWindow.document;
    const target = this.isDayTime
      ? doc.getElementById('morningBlock')
      : doc.getElementById('nightBlockScroll');
    target?.scrollIntoView(true);
  }

  async thumpsUpDownRes(response: boolean): Promise<void> {
    if (response) {
      this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'instructionsHelpful' }));
    } else {
      this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'instructionsNotHelpful' }));
    }
    await this.conn.updateSupportTicketFeedback(this.supportTicketId, response);
    this.user.set('instructionsFeedbackResponse', response ? 'yes' : 'no');
    await this.user.save();
    this.thumbsUpDown = false;
  }

  toggleProductUpdatePopup(event?: any): void {
    this.showGoToCart = event?.fromInstruction === KnowMoreClicked.NOT_YET_STARTED;
    this.dontShowCTA = event?.fromInstruction === KnowMoreClicked.NEW;
    this.productUpdatePopupEnabled = !this.productUpdatePopupEnabled;
    const eventName = !this.productUpdatePopupEnabled
      ? 'instruction-page-product-update-pop-up-closed'
      : 'instruction-page-product-update-pop-up-opened';
    const channels = this.productUpdatePopupEnabled ? [] : [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: eventName }), channels);
  }

  handleAutoPopup(): void {
    if (!this.latestFollowupReport?.regimenModifications?.length) {
      return;
    }

    const storageKey = 'product_update_popup_count';
    const storageObjectIdKey = 'product_update_popup_report_id';
    const DEFAULT_COUNT = 0;
    const RADIX_DECIMAL = 10;
    const MAX_COUNT = 2;

    const storedReportId = localStorage.getItem(storageObjectIdKey);
    const currentReportId = this.latestFollowupReport.objectId;

    // Reset count if report ID is different
    if (storedReportId !== currentReportId) {
      localStorage.setItem(storageKey, `${DEFAULT_COUNT}`);
      localStorage.setItem(storageObjectIdKey, currentReportId);
    }

    const popupCount = parseInt(localStorage.getItem(storageKey) || `${DEFAULT_COUNT}`, RADIX_DECIMAL);

    if (popupCount < MAX_COUNT) {
      localStorage.setItem(storageKey, (popupCount + 1).toString());

      if (!this.productUpdatePopupEnabled) {
        this.toggleProductUpdatePopup(KnowMoreClicked.AUTO);
      }
    }
  }

  async getRegimenModificationsAndDoctorInfo(): Promise<void> {
    const response = await this.getAllFollowUpsOfUser();

    if (!response || response.length === 0) return;

    this.latestFollowupReport = JSON.parse(JSON.stringify(response[0]));
    const doctorId = this.latestFollowupReport.doctor?.objectId;
    const doctor = doctorId ? await this.userAllocatedDoctorService.getDoctorById(doctorId) : null;
    this.userDrImage = doctor?.doctorDisplayImage || doctor?.DoctorImageThumbnail
      || this.defaultDoctorImage;
    this.latestReportDoctorName = doctor?.DoctorDisplayName;
    this.regimenModifications = this.latestFollowupReport.regimenModifications;

    await this.updateCollapsableCardRemovedStatus();
  }

  async getAllFollowUpsOfUser(): Promise<any> {
    const where = { user: this.user, isSecondaryComparison: false };
    return this.conn.fetchFollowUpReports({ where, descending: 'createdAt' });
  }

  private isSameDay(date1: Date, date2: Date): boolean {
    return date1.getDate() === date2.getDate()
           && date1.getMonth() === date2.getMonth()
           && date1.getFullYear() === date2.getFullYear();
  }

  async onDateSelect(selectedDay: any): Promise<void> {
    this.selectedDate = new Date(selectedDay.fullDate);

    // Update selected state in weekArray
    // tslint:disable-next-line:typedef
    this.weekArray = this.weekArray.map((day) => ({
      ...day,
      isSelected: this.isSameDay(day.fullDate, this.selectedDate),
    }));

    // Create new references to trigger change detection
    this.todayDay = selectedDay.fullDate.getDate();
    this.todayDayVal = selectedDay.fullDate.getDay();

    const eventName = 'instructions_date_changed';
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: eventName }));
  }

  /**
   * Toggles the isOpen value for a product in either onHold or removed arrays
   * @param productId - The ID of the product to toggle
   */
  toggleProductCollapse(productId: string): void {
    // Check in onHold array
    const onHoldProduct = this.collapsableCard.onHold.find(
      (item: CollapsableCardItem): boolean => item.productId === productId,
    );
    if (onHoldProduct) {
      onHoldProduct.isOpen = !onHoldProduct.isOpen;
    }

    // Check in removed array
    const removedProduct = this.collapsableCard.removed.find(
      (item: CollapsableCardItem): boolean => item.productId === productId,
    );
    if (removedProduct) {
      removedProduct.isOpen = !removedProduct.isOpen;
    }
  }

  goToCart(): void {
    this.router.navigate(['cart']);
    const eventName = 'instruction-page-product-update-pop-up-go-to-cart';
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: eventName }));
  }

  private async initRouteMode(): Promise<void> {
    const regimenClass = (this.activatedRoute.snapshot.queryParams[REGIMEN_QUERY_PARAMS.CLASS] as RegimenClass)
      || this.appConfig.Shared.Regimen.Class.FACE;
    const regimens = await this.regimenService.getRegimens();
    const regimen = regimens.find(r => r.class === regimenClass);
    if (regimen) {
      this.regimenObject = regimen;
    }
    this.dietBannerV2 = this.experimentService.dietBannerV2;
    this.dietBannerRevamp = this.experimentService.isRetentionHomeRevampExperimentEnabled;
    this.newInstructionUIExperiment = this.experimentService.newInstructionUIExperiment;
    this.supportTicketId = this.activatedRoute.snapshot.queryParams[REGIMEN_QUERY_PARAMS.SUPPORT_TICKET_ID];

    this.isInternalUser = this.conn.isInternalUser();
    this.keyboardSubscription = this.broadcast.on<boolean>('KEYBOARD_VISIBLE')
      .subscribe(visible => this.isKeyboardVisible = visible);

    this.routeSubscription = this.activatedRoute.queryParams.subscribe(async (params: Params) => {
      const newClass = params[REGIMEN_QUERY_PARAMS.CLASS] as RegimenClass | undefined;
      if (newClass && newClass !== this.regimen?.class) {
        this.initialLoadComplete = false;
        const regs = await this.regimenService.getRegimens();
        const reg = regs.find(r => r.class === newClass);
        if (reg) this.regimenObject = reg;
      }
    });
  }

  async readMoreAboutProducts(): Promise<void> {
    this.eventLoggerService.trackEventForClass(FirebaseAndBranchEvent.REGIMEN_VIEW_READ_ABOUT_PRODUCTS, this.regimen.class, { username: this.user?.get('username') });
    await this.router.navigate(['/user/regimen/products'],
      { queryParams: { class: this.regimen.class, username: this.user?.get('username'), regimenId: this.regimen.regimenId } });
  }

  async showPriceDetails(): Promise<void> {
    this.eventLoggerService.trackInParse('KNOW_MORE', ApiClientConstant.Event.Type.ORDER);
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'instruction-full-details' }));
    await this.readMoreAboutProducts();
  }

  async reorder(): Promise<void> {
    if (this.isInternalUser) return;
    const morningProducts = (this.regimen.morning ?? []).map((m: any): string => m.product.objectId);
    const nightProducts = (this.regimen.night ?? []).map((n: any): string => n.product.objectId);
    const ids = Array.from(new Set([...morningProducts, ...nightProducts]));
    this.conn.navigateToURL(`/cart?products=${ids.join(',')}&type=REGIMEN`);
  }

  async buyRegimen(): Promise<void> {
    this.trackBuyRegimenEvents();
    const orderState = this.user?.get('orderState');
    this.router.navigate(['/user/checkout'], {
      queryParams: {
        type: 'REGIMEN',
        regimenId: this.regimen.regimenId,
        useCureSkinCash: String(this.experimentService.shouldUseCureSkinCash(orderState)),
      },
    });
    this.eventLoggerService.logEventInBranchAndFirebaseFromiOSForClass(FirebaseAndBranchEvent.BUY_NOW_CLICKED, this.regimen.class);
  }

  private trackBuyRegimenEvents(): void {
    this.eventLoggerService.cleverTapEvent('buyNowRegimen',
      JSON.stringify({ regimenId: this.regimen.regimenId, regimenClass: this.regimen.class }), [
      this.appConfig.Shared.EventTracker.MIXPANEL,
      this.appConfig.Shared.EventTracker.AMPLITUDE,
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
    this.eventLoggerService.trackInParse('BUY_NOW', ApiClientConstant.Event.Type.ORDER);
    this.eventLoggerService.trackEventForClass(FirebaseAndBranchEvent.BUY_NOW_CLICKED, this.regimen.class);
    this.eventLoggerService.trackInFirebaseAndBranchForClass(FirebaseAndBranchEvent.BUY_NOW_CLICKED, this.regimen.class);
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'instructions-buy-now-regimen' }));
  }

  ngOnDestroy(): void {
    this.initialLoadComplete = false;
    this.routeSubscription?.unsubscribe();
    this.keyboardSubscription?.unsubscribe();
    if (this.nightElementObserver) {
      this.nightElementObserver.disconnect();
      this.nightElementObserver = null;
    }
  }

  setReminderToggleState(event: Event): void {
    const toggleValue = !!(event.target as HTMLInputElement).checked;

    if (!toggleValue) {
      this.toggleInstructionReminderPopup(true);
      return;
    }

    if (this.isRouteMode) {
      this.saveReminderToggle(toggleValue);
    } else {
      this.reminderToggleChange.emit(toggleValue);
    }
  }

  toggleInstructionReminderPopup(showPopUp: boolean): void {
    this.showInstructionReminderTurnOffPopup = !!showPopUp;
  }

  turnOffInstructionReminder(): void {
    if (this.isRouteMode) {
      this.saveReminderToggle(false);
    } else {
      this.reminderToggleChange.emit(false);
    }
    this.toggleInstructionReminderPopup(false);
  }

  private async saveReminderToggle(enabled: boolean): Promise<void> {
    this.reminderToggle = enabled;
    this.reminderToggle = await this.instructionsService.saveReminderToggle(enabled);
  }

  async onReminderBannerToggleChange(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    await this.toggleRemindersBanner(input.checked);
  }

  async toggleRemindersBanner(enabled: boolean): Promise<void> {
    if (!this.user) return;
    this.reminderToggle = enabled;
    const saved = await this.instructionsService.saveReminderToggle(enabled);
    this.reminderToggle = saved;
    if (saved !== enabled) return;

    this.showReminderContainer = true;
    if (enabled) {
      this.reminderEventSent = true;
      setTimeout((): void => {
        this.closeReminderBanner();
        if (!this.reminderToggle) {
          this.reminderEventSent = false;
          this.showReminderContainer = true;
        }
      }, this.REMINDER_CLOSE_DELAY_MS);
    } else {
      this.reminderEventSent = false;
      this.showReminderContainer = true;
    }
  }

  closeReminderBanner(): void {
    this.showReminderContainer = false;
  }
}
